export const binaryToUtf8 = (bytes) => {
    return new TextDecoder().decode(bytes);
};
export const utf8ToBinary = (utf8) => {
    return new TextEncoder().encode(utf8);
};
export const binaryToHex = (bytes, addPrefix = false) => {
    if (addPrefix) {
        return `0x${Buffer.from(bytes).toString('hex')}`;
    }
    return Buffer.from(bytes).toString('hex');
};
export const hexToBinary = (hex) => {
    if (hex.startsWith('0x')) {
        hex = hex.slice(2);
    }
    if (hex.length % 2 !== 0) {
        throw new Error(`Hex string length must be even, received: 0x${hex}`);
    }
    const result = Buffer.from(hex, 'hex');
    if (hex.length !== result.length * 2) {
        throw new Error(`Hex string input is likely malformed, received: 0x${hex}`);
    }
    return result;
};
export const areEqualBinaries = (arr1, arr2) => {
    return Buffer.compare(arr1, arr2) === 0;
};
